/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export { default as IconButtonActive } from './icon-button-active.story';
export { default as IconButtonDefault } from './icon-button-default.story';
export { default as IconButtonDisabled } from './icon-button-disabled.story';
export { default as IconButtonFloating } from './icon-button-floating.story';
export { default as IconButtonLoading } from './icon-button-loading.story';
export { default as IconButtonSizes } from './icon-button-sizes.story';
export { default as IconButtonTone } from './icon-button-tone.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import IconButtonActiveSrcRaw from './icon-button-active.story?raw';
import IconButtonDefaultSrcRaw from './icon-button-default.story?raw';
import IconButtonDisabledSrcRaw from './icon-button-disabled.story?raw';
import IconButtonFloatingSrcRaw from './icon-button-floating.story?raw';
import IconButtonLoadingSrcRaw from './icon-button-loading.story?raw';
import IconButtonSizesSrcRaw from './icon-button-sizes.story?raw';
import IconButtonToneSrcRaw from './icon-button-tone.story?raw';

export const IconButtonActiveSrc = removeLicenseHeader(IconButtonActiveSrcRaw);
export const IconButtonDefaultSrc = removeLicenseHeader(
  IconButtonDefaultSrcRaw,
);
export const IconButtonDisabledSrc = removeLicenseHeader(
  IconButtonDisabledSrcRaw,
);
export const IconButtonFloatingSrc = removeLicenseHeader(
  IconButtonFloatingSrcRaw,
);
export const IconButtonLoadingSrc = removeLicenseHeader(
  IconButtonLoadingSrcRaw,
);
export const IconButtonSizesSrc = removeLicenseHeader(IconButtonSizesSrcRaw);
export const IconButtonToneSrc = removeLicenseHeader(IconButtonToneSrcRaw);
